import { buildFamsPageMessages } from 'config/fams-menu';

export default {
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  ...buildFamsPageMessages('zh-CN'),
};
